import "./styles.scss";

import { useTranslation } from "react-i18next";
import classnames from "classnames";

import TrackerButtonTimer from "./components/Timer";

import toHoursAndMinutes from "libs/helpers/toHoursAndMinutes";

import { ReactComponent as PlayIcon } from "assets/icons/time-tracker-play.svg";
import { ReactComponent as PauseIcon } from "assets/icons/time-tracker-pause.svg";

const mainClass = "tracker-button";

const TrackerButton = ({
  time,
  start_time_tracked,
  disable_tracking,
  isActive,
  onClick,
  onLabelClick,
}) => {
  const { t } = useTranslation();

  const onLabelClickDisabled = disable_tracking && time?.$numberDecimal === 0;

  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--active`]: !!start_time_tracked || isActive,
        [`${mainClass}--tracking`]: !!start_time_tracked,
      })}
    >
      {!!start_time_tracked ? (
        <span>
          <TrackerButtonTimer start_time_tracked={start_time_tracked} />
        </span>
      ) : (
        <span
          className={classnames({
            action: typeof onLabelClick === "function" && !onLabelClickDisabled,
          })}
          onClick={
            typeof onLabelClick === "function" && !onLabelClickDisabled
              ? onLabelClick
              : undefined
          }
        >
          {time?.$numberDecimal
            ? toHoursAndMinutes(time?.$numberDecimal).formatted
            : !disable_tracking
              ? t("Add time")
              : "-"}
        </span>
      )}
      {!disable_tracking && typeof onClick === "function" && (
        <button onClick={onClick}>
          {!!start_time_tracked || isActive ? <PauseIcon /> : <PlayIcon />}
        </button>
      )}
    </div>
  );
};

export default TrackerButton;
